import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//Prime modules
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ContactComponent } from './contact/contact.component';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChatComponent } from './chat/chat.component';
import { DatePipe } from '@angular/common';
import { HelperChatComponent } from './helper-chat/helper-chat.component';
import { UtcToLocalPipe } from '../../pipe/utc-to-local.pipe';
import { GlobalOrderCompleteModalComponent } from './global-order-complete-modal/global-order-complete-modal.component';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';

const primeModules = [
  ButtonModule,
  CardModule,
  DropdownModule,
  FormsModule,
  SidebarModule,
  DialogModule,
  RadioButtonModule,
  InputTextModule,
  InputTextareaModule,
  ReactiveFormsModule,
  ToastModule,
  AvatarModule,
  AvatarGroupModule,
  ProgressBarModule,
  ProgressSpinnerModule,
  PasswordModule,
  TooltipModule,
  OverlayPanelModule
]


@NgModule({
  declarations: [
    ContactComponent,
    ChatComponent,
    HelperChatComponent,
    UtcToLocalPipe,
    GlobalOrderCompleteModalComponent
  ],
  imports: [
    CommonModule,
    ...primeModules,
    TranslateModule
  ],
  providers: [DatePipe],
  exports: [...primeModules, ContactComponent, ChatComponent, HelperChatComponent, UtcToLocalPipe, GlobalOrderCompleteModalComponent]
})
export class SharedModule { }
